import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
  Paper,
  Alert,
  FormControlLabel,
  Checkbox,
  Grid,
  Modal,
  Divider,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useAppData } from "../../redux/appDataProvider";
import ApiClient from "../../utilities/apiClient";
import AppConfig from "../../AppConfig";
import { useSelector } from "react-redux";
import MyLodder from "../../components/ddpiloader";

const ActivatePoa = () => {
  const [step, setStep] = useState(1);
  const [status, setStatus] = useState("pending");
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [pdfError, setPdfError] = useState(null);
  const [showLodder, setShowLodder] = useState(false);
  const [esignSuccess, setEsignSuccess] = useState(null);
  const [failureModalOpen, setFailureModalOpen] = useState(false);
  const [dpinfo,setDpInfo]=useState(null)
  const [isDDPIActive, setIsDDPIActive] = useState(false);
  const [openModal, setOpenModal] = useState(false);


  console.log(dpinfo)

  const apiToken = useSelector((state) => state.auth.apiToken);
  const { userInfo } = useAppData();

  useEffect(() => {
    fetchDDPIStatus()
    fetchClintDpInfo()

  }, [])

   const fetchClintDpInfo = async () => {
      try {
        // Replace this with your actual data fetching logic
        // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
        setShowLodder(true)
        const apiClient = new ApiClient(apiToken);
        apiClient.fetchData(
          AppConfig.api.Client.clientDpDetails,
          "POST",
          {
            "CLIENT_ID": userInfo.CLIENT_ID || localStorage.getItem("userid") ,
          })
          .then((response) => {
            console.log("DDPI response", response?.data?.["Success Description"]?.[0]);
            setShowLodder(false)
            if (response && response?.data?.Success == "True" && response?.data?.hasOwnProperty("Success Description")) {
              let responseData = response?.data?.["Success Description"];
              console.log(`fetchClintDpInfoResData ${responseData[0]}`);
              if (Array.isArray(responseData) && responseData.length > 0) {
                console.log(`setDpInfo`,responseData?.[0]);
                setDpInfo(responseData[0]);
                if (responseData[0]?.DDPI === "Y") {
                  setStep(3)
                } 
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error('Error fetching holding data:', error);
      }
    };

  const fetchDDPIStatus = async () => {
    try {
      const apiClient = new ApiClient(apiToken);
      const payload = { client_id: userInfo.CLIENT_ID || localStorage.getItem("userid") };

      const response = await apiClient.fetchData(AppConfig.api.poa.eSignStatus, "POST", payload);

      console.log("fetchDDPIStatus", response ,response?.status , response?.stage)

      if (response?.status === 200 && response?.stage) {
        if (response?.stage === 'signed' || response?.stage === 'approved' || response?.stage === 'initiated') {
          setStep(3);
          setStatus(response?.stage);
        } else {
          setStep(1);
        }

      }
      
    
    } catch (error) {
      console.error("Error fetching DDPI eSign status:", error);
    }
  };


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const eSignSuccess = params.get("eSignSuccess");

    if (eSignSuccess === "true") {
      setEsignSuccess(true);
      setStatus("signed"); // ✅ show pending message
      setStep(3); // move to status view
    } else if (eSignSuccess === "false") {
      setEsignSuccess(false);
      setFailureModalOpen(true); // show failure modal
    }

    // Trim the query param from the URL (no reload)
    if (eSignSuccess !== null) {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  // --- Handlers ---
  const handleOpenPreview = async () => {
    try {
      setShowLodder(true);
      setPdfError(false);

      // Example payload
      const payload = {
        data :{
        email: userInfo.CLIENT_ID_MAIL,
        mobile: userInfo.MOBILE_NO,
        type: "DDPIestamp",
        source: "backoffice",
        form: "DDPI",
        clientData: {
          clientCode: userInfo.CLIENT_ID, holder1Name: userInfo.CLIENT_NAME,
          dematAccountNo: userInfo.CLIENT_DP_CODE,
          address: userInfo.CL_RESI_ADD1 + " " + userInfo.CL_RESI_ADD2 + " " + userInfo.CL_RESI_ADD3,
          mobileNo: userInfo.MOBILE_NO,
          holder1Name: userInfo.CLIENT_NAME,
          pan: userInfo.PAN_NO,
          dob: userInfo.BIRTH_DATE
        }
        },
      };

      console.log("handleOpenPreview",payload)

      const apiClient = new ApiClient(apiToken);
      const response = await apiClient.fetchData(AppConfig.api.poa.preview, "POST", payload);
      console.log("PDF Preview response",response)
      if (response?.status === 200) {
        const base64PDF = response?.data?.base64Data;
        const blob = new Blob([Uint8Array.from(atob(base64PDF), (c) => c.charCodeAt(0))], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setPreviewModalOpen(true);
      } else {
        setPreviewModalOpen(true);
        setPdfError(response?.data?.message || "Failed to load PDF preview.");
      }
    } catch (err) {
      console.error(err);
      setPreviewModalOpen(true);
      setPdfError(err?.data?.message || "An error occurred while loading the form.");
    } finally {
      setShowLodder(false);
    }
  };
const handleProceedToESign = async () => {
  try {
    setShowLodder(true);

    const payload = {
      data:{
      email: userInfo.CLIENT_ID_MAIL,
      mobile: userInfo.MOBILE_NO,
      type: "DDPIestamp",
      source: "ddpi",
      form: "DDPI",
      clientData: {
      clientCode:userInfo.CLIENT_ID,
      holder1Name: userInfo.CLIENT_NAME,
      dematAccountNo: userInfo.CLIENT_DP_CODE,
      address:userInfo.CL_RESI_ADD1+" "+userInfo.CL_RESI_ADD2+" "+userInfo.CL_RESI_ADD3,
      mobileNo:userInfo.MOBILE_NO,
      pan:userInfo.PAN_NO,
      dob:userInfo.BIRTH_DATE
      }
    }
  };

    const apiClient = new ApiClient(apiToken);
    const response = await apiClient.fetchData(
      AppConfig.api.poa.authorize,   // <-- your API URL from config
      "POST",
      payload
    );

    console.log("authorize response",response?.data)

    // const response = {
    //   "status": 200,
    //   "url": "https://uat.esign-proteantech.in/esign/esign-verify?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWNpcGllbnRJZCI6IjRiNzA3YmZmLTRlN2ItNDhhZC05ODZkLTVjY2VlMWY1MDI3OCIsImlzUGF5bWVudEFwcGxpY2FibGUiOmZhbHNlLCJpYXQiOjE3NjE1NDI5MjgsImV4cCI6MTc2MTYyOTMyOH0.3TYpWHo5U16DEkgyshBNFUJ8ipF2Jzk1v1G-QGR9KI0",
    //   "response": 200
    // }
    if (response?.data?.status === 200 && response?.data?.data?.success && response?.data?.data?.code !== "2") {
      // ✅ REDIRECT USER TO E-SIGN PAGE
      window.location.href = response?.data?.data?.url;
    }
    else{
      alert( response?.data?.data?.message || "Something went wrong while initiating eSign.Please try again")
    }

  } catch (error) {
    console.error(error);
    alert(error?.data?.data?.message || "Something went wrong while initiating eSign");
  } finally {
    setShowLodder(false);
  }
};


  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setPdfError(null);
    setIsAcknowledged(false);
  };

  const sanitizedUrl = pdfUrl ? `${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0` : "";

  // --- UI ---
  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        color="primary"
        sx={{
          fontSize: {
            xs: '1.5rem',  // Mobile phones (0px and up)
            sm: '1.75rem', // Small tablets (600px and up)
            md: '2rem',    // Tablets (900px and up)
            lg: '2.125rem', // Desktops (1200px and up)
            xl: '2.25rem'  // Large desktops (1536px and up)
          },
          textAlign: {
            xs: 'center',  // Center on mobile
            sm: 'left'     // Left align on tablet and above
          },
          mb: {
            xs: 1,         // Smaller margin on mobile
            sm: 2          // Regular margin on larger screens
          }
        }}
      >
        Activate Demat Debit and Pledge Instruction (DDPI)
      </Typography>

      <Typography
        variant="subtitle1"
        color="text.secondary"
        sx={{
          mb: {
            xs: 2,         // Smaller margin on mobile
            sm: 3          // Regular margin on tablet and above
          },
          fontSize: {
            xs: '0.875rem', // Slightly smaller on mobile
            sm: '1rem'      // Regular size on tablet and above
          },
          textAlign: {
            xs: 'center',   // Center on mobile
            sm: 'left'      // Left align on tablet and above
          },
          lineHeight: {
            xs: 1.4,        // Tighter line height on mobile
            sm: 1.6         // Regular line height on larger screens
          },
          px: {
            xs: 2,          // Horizontal padding on mobile for better readability
            sm: 0           // No horizontal padding on larger screens
          }
        }}
      >
        Review your DDPI form, eSign with Aadhaar, and activate your authorization securely.
      </Typography>

      {/* Step 1 - Preview */}
      {step === 1 && (
        <Card sx={{ borderRadius: 3, overflow: "hidden" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "#fff !important",
              color: "black",
              px: 3,
              py: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <DescriptionIcon />
              <Typography
                variant="h6"
                sx={{
                  fontSize: {
                    xs: '1rem',    // Mobile phones
                    sm: '1.125rem', // Small tablets
                    md: '1.25rem',  // Tablets and up
                  },
             
                }}
              >
                Step 1: Preview DPPI Form
              </Typography>
            </Box>
            <PictureAsPdfIcon
              sx={{
                fontSize: {
                  xs: 24,         // Smaller on mobile
                  sm: 28,         // Medium on tablets
                  md: 30          // Original size on desktop
                },
                opacity: 0.8
              }}
            />
          </Box>

          <CardContent>
            <Typography
              variant="body1"
              sx={{
                mb: {
                  xs: 1,        // Less margin on mobile
                  sm: 2         // Regular margin on tablets and up
                },
                fontSize: {
                  xs: '0.875rem', // Slightly smaller on mobile
                  sm: '1rem'      // Regular size on tablets and up
                },
                lineHeight: {
                  xs: 1.5,       // Tighter line height on mobile
                  sm: 1.6        // Regular line height on larger screens
                },
                textAlign: {
                  xs: 'left',    // Left align on all screens
                },
                px: {
                  xs: 0,         // No horizontal padding
                  sm: 0
                }
              }}
            >
              Please review the Demat Debit and Pledge Instruction (DDPI) form carefully. Once you are ready, proceed
              with Aadhaar eSign to authorize it.
            </Typography>

            <Box textAlign="center" mt={3}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleOpenPreview}
                sx={{ px: 4, py: 1.2, fontWeight: 600 }}
              >
                Preview DDPI Form
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Step 3 - Status */}
      {step === 3 && (
        <Card sx={{ mt: 3, borderRadius: 3 }}>
          <CardContent>
            {/* ✅ Show when DDPI is already active */}
            {dpinfo?.DDPI === "Y" && (
              <Box sx={{ display: "flex", alignItems: "center", color: "white" }}>
                <CheckCircleOutlineIcon sx={{ mr: 1 }} />
                <Typography
                  sx={{
                    fontSize: {
                      xs: '0.875rem',  // Mobile phones
                      sm: '0.9rem',    // Small tablets
                      md: '1rem',      // Tablets and up
                    },
                    lineHeight: {
                      xs: 1.4,         // Tighter on mobile
                      sm: 1.5,         // Regular on larger screens
                    },
                    fontWeight: {
                      xs: 400,         // Normal weight on mobile
                      sm: 400,
                    }
                  }}
                >
                  Your DDPI is already active and linked to your account
                </Typography>
              </Box>
            )}

            {status === "signed" && (
              <Box sx={{ display: "flex", alignItems: "center", color: "white" }}>
                <CheckCircleOutlineIcon sx={{ mr: 1 }} />
                <Typography
                  sx={{
                    fontSize: {
                      xs: '0.875rem',
                      sm: '0.9rem',
                      md: '1rem',
                    },
                    lineHeight: {
                      xs: 1.4,
                      sm: 1.5,
                    },
                    fontWeight: {
                      xs: 400,
                      sm: 400,
                    }
                  }}
                >
                  DDPI successfully eSigned. Awaiting approval.
                </Typography>
              </Box>
            )}

            {status === "approved" && (
              <Box sx={{ display: "flex", alignItems: "center", color: "white" }}>
                <CheckCircleOutlineIcon sx={{ mr: 1 }} />
                <Typography
                  sx={{
                    fontSize: {
                      xs: '0.875rem',
                      sm: '0.9rem',
                      md: '1rem',
                    },
                    lineHeight: {
                      xs: 1.4,
                      sm: 1.5,
                    },
                    fontWeight: {
                      xs: 400,
                      sm: 400,
                    }
                  }}
                >
                  Your DDPI mandate has been successfully activated and is now live on your account
                </Typography>
              </Box>
            )}
            {status === "initiated" && (
              <Box sx={{ display: "flex", alignItems: "center", color: "white" }}>
                <CheckCircleOutlineIcon sx={{ mr: 1 }} />
                <Typography
                  sx={{
                    fontSize: {
                      xs: '0.875rem',
                      sm: '0.9rem',
                      md: '1rem',
                    },
                    lineHeight: {
                      xs: 1.4,
                      sm: 1.5,
                    },
                    fontWeight: {
                      xs: 400,
                      sm: 400,
                    }
                  }}
                >
                  Your DDPI eSign link will be delivered to your gmail shortly. Please check your gmail.
                </Typography>
              </Box>
            )}
            {status === "rejected" && (
              <Box sx={{ display: "flex", alignItems: "center", color: "red" }}>
                <ErrorOutlineIcon sx={{ mr: 1 }} />
                <Typography>DDPI request rejected. Please contact support.</Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      {/* PDF Preview Modal */}
      <Modal open={previewModalOpen} onClose={handleClosePreview}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95vw",
            maxWidth: "950px",
            maxHeight: "85vh",
            bgcolor: "#101820",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "white", display: "flex", alignItems: "center", gap: 1 }}
          >
            <PictureAsPdfIcon sx={{ color: "#F3D45E" }} />
            DDPI Form Preview
          </Typography>

          {pdfError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {pdfError}
            </Alert>
          )}

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="300px">
              <CircularProgress color="warning" />
            </Box>
          ) : pdfUrl ? (
            <Paper
              elevation={4}
              sx={{
                overflow: "hidden",
                borderRadius: 2,
                height: "320px",
                border: "1px solid #333",
              }}
            >
              <object data={sanitizedUrl} type="application/pdf" width="100%" height="100%">
                <Typography sx={{ p: 2, color: "white" }}>
                  PDF preview not supported.{" "}
                  <a
                    href={sanitizedUrl}
                    download={`${userInfo?.CLIENT_ID}_DDPI_form.pdf`}
                    style={{ color: "#F3D45E" }}
                  >
                    Download here
                  </a>
                </Typography>
              </object>
            </Paper>
          ) : (
            <Typography sx={{ color: "white", textAlign: "center", py: 4 }}>
              No PDF available for preview.
            </Typography>
          )}

          {/* Acknowledgment & Buttons */}
          {pdfUrl && (
            <>
              <Grid sx={{ mt: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAcknowledged}
                      onChange={(e) => setIsAcknowledged(e.target.checked)}
                      sx={{ color: "#F3D45E" }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                      I have read and agree to the Terms & Conditions, Disclaimers, and Privacy Policy.
                    </Typography>
                  }
                />
              </Grid>

              <Divider sx={{ my: 2, borderColor: "#333" }} />

              <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                <Button
                  variant="outlined"
                  onClick={handleClosePreview}
                  sx={{
                    fontWeight: 600,
                    color: "#000",
                    borderColor: "#F3D45E",
                    "&:hover": { borderColor: "#ffdd57"},
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!isAcknowledged}
                  sx={{
                    fontWeight: 600,
                    backgroundColor: isAcknowledged ? "#F3D45E" : "#ccc",
                    color: isAcknowledged ? "#000" : "#666",
                  }}
                  onClick={handleProceedToESign}
                >
                  Proceed to Aadhaar eSign
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      <MyLodder canShow={showLodder}  message="Please wait, it will take a moment..."/>

      <Modal open={failureModalOpen} onClose={() => setFailureModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",                // ✅ responsive width
            maxWidth: 400,               // ✅ cap width for larger screens
            bgcolor: "white",
            borderRadius: 2,
            p: { xs: 2, sm: 3 },         // ✅ smaller padding on mobile
            textAlign: "center",
            boxShadow: 24,
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 50, mb: 1 }} />
          <Typography variant="h6" sx={{ mb: 2,color: "#000" }}>
            eSign Failed
          </Typography>
          <Typography variant="body2" sx={{ mb: 3,color: "#000" }}>
            Something went wrong during the Aadhaar eSign process. Please try again.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setFailureModalOpen(false)}
            sx={{
              backgroundColor: "#F3D45E",
              color: "#000",
              fontWeight: 600,
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>

      <Modal open={esignSuccess} onClose={() => setEsignSuccess(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",                // ✅ responsive width
            maxWidth: 400,               // ✅ cap width for larger screens
            bgcolor: "white",
            borderRadius: 2,
            p: { xs: 2, sm: 3 },         // ✅ smaller padding on mobile
            textAlign: "center",
            boxShadow: 24,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 50, color: "#4CAF50", }} />
          <Typography variant="h6" sx={{ mb: 2,color: "#000"  }}>
            eSign Successful
          </Typography>
          <Typography variant="body2" sx={{ mb: 3,color: "#000" }}>
            Your Aadhaar eSign process has been successfully completed.
            Please wait while we verify and activate your DDPI mandate.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setEsignSuccess(false)}
            sx={{
              backgroundColor: "#F3D45E",
              color: "#000",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#F3D45E" },
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>
       <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",                // ✅ responsive width
            maxWidth: 400,               // ✅ cap width for larger screens
            bgcolor: "white",
            borderRadius: 2,
            p: { xs: 2, sm: 3 },         // ✅ smaller padding on mobile
            textAlign: "center",
            boxShadow: 24,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 50, color: "#4CAF50", }} />
          <Typography variant="h6" sx={{ mb: 2,color: "#000"  }}>
            eSign Initiated
          </Typography>
          <Typography variant="body2" sx={{ mb: 3,color: "#000" }}>
           Your DDPI eSign link will be delivered to your gmail shortly. Please check your gmail.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setOpenModal(false)}
            sx={{
              backgroundColor: "#F3D45E",
              color: "#000",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#F3D45E" },
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>


    </Box>
  );
};

export default ActivatePoa;
